(() => {
  if (window.PawKodaThemeInitialized) return;
  window.PawKodaThemeInitialized = true;

  document.addEventListener('click', (event) => {
    const matchButton = event.target.closest('[data-pk-match-button]');
    if (matchButton) {
      const finder = matchButton.closest('[data-pk-finder]');
      if (!finder) return;

      const target = matchButton.dataset.pkMatchButton;
      finder.querySelectorAll('[data-pk-match-button]').forEach((button) => {
        button.setAttribute('aria-selected', String(button === matchButton));
      });
      finder.querySelectorAll('[data-pk-match-result]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.pkMatchResult === target);
      });
      return;
    }

    const mobileLink = event.target.closest('[data-pk-mobile-link]');
    if (mobileLink) {
      const details = mobileLink.closest('details');
      if (details) details.removeAttribute('open');
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-pk-finder]').forEach((finder) => {
      const selected = finder.querySelector('[data-pk-match-button][aria-selected="true"]') || finder.querySelector('[data-pk-match-button]');
      if (selected) selected.click();
    });
  });
})();
